<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 展示情報の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>展示情報の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/exhibit.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。<br>
          ※展示登録数には制限があります。制限数を変更したい場合は弊社担当へご連絡下さい。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter・属性
        </div>
        <div class="manual-explain">
          展示一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、ID、名称、属性（プルダウンによるフィルタリング）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 展示一覧
        </div>
        <div class="manual-explain">
          登録済みの展示情報の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Exhibit Information Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Exhibit Information Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_exhibit.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Add Button
          </div>
          <div class="manual-explain">
            Clicking this button opens the add screen.<br>
            * There is a limit on the number of exhibits that can be registered. If you wish to change the limit, please contact our representative.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Delete Button
          </div>
          <div class="manual-explain">
            Clicking this button deletes the selected information.<br>
            The button becomes active when the delete checkboxes in the list are selected.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Filter/Attributes
          </div>
          <div class="manual-explain">
            Filters the data displayed in the exhibit list.<br>
            * Filters can be applied by ID, name, and attributes (using dropdown filtering).
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Exhibit List
          </div>
          <div class="manual-explain">
            A list of registered exhibit information is displayed.<br>
            Clicking the edit icon opens the edit screen.<br>
          </div>

        </mat-card-content>
      </mat-card>

    </div>  
  </div>
